import React, { useState } from "react";
import "../index.css";

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const imagesPerView = window.innerWidth < 768 ? 1 : 4;

  const handlePrevious = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, images.length - imagesPerView)
    );
  };

  //   const getCurrentSlideIndex = () => {
  //     return Math.floor(currentIndex / imagesPerView);
  //   };

  return (
    <div className="image-slider">
      <div className="slider-container">
        <button
          className="nav-button prev"
          onClick={handlePrevious}
          disabled={currentIndex === 0}
        >
          &#8592;
        </button>

        <div className="images-container">
          {images.map((image, index) => (
            <div
              key={index}
              className="image-wrapper"
              style={{
                transform: `translateX(${-currentIndex * (8 + 1)}rem)`, // 8rem for image width + 1rem for gap
              }}
            >
              <img
                src={image.url || image}
                alt={image.caption || `Slide ${index + 1}`}
                className="slider-image"
              />
              <div className="image-caption">
                {image.caption || `Image ${index + 1}`}
              </div>
            </div>
          ))}
        </div>

        <button
          className="nav-button next"
          onClick={handleNext}
          disabled={currentIndex >= images.length - imagesPerView}
        >
          &#8594;
        </button>
      </div>

      {/* <div className="pagination">
        {[...Array(Math.ceil(images.length / imagesPerView))].map(
          (_, index) => (
            <span
              key={index}
              className={`dot ${
                getCurrentSlideIndex() === index ? "active" : ""
              }`}
              onClick={() => setCurrentIndex(index * imagesPerView)}
            />
          )
        )}
      </div> */}
    </div>
  );
};

export default ImageSlider;
